var error = {
  translation: {
    error: {
      coreNotFound: 'Failed to fetch core settings',
      domainNotAllowed: 'You cannot register with an email from this domain',
      emailAlreadyInUse: 'Email already in use',
      insufficientPermissions: 'Insufficient permissions',
      invalidCurrentPassword: 'Invalid current password',
      invalidPermissions: 'Please select at least one permission',
      invalidUsernameOrPassword: 'Invalid username or password',
      localRegistrationDisabled: 'User local registration is disabled by the administrator',
      noInternetConnection: 'No internet connection',
      noOidcProfileFound: 'No OIDC profile found',
      policyNotAccepted: 'Please accept Terms of Service and Privacy Policy',
      registrationDisabled: 'All user registration is disabled by the administrator',
      serverConnectionFailed: 'Server connection failed',
      ssoRegistrationDisabled: 'User SSO registration is disabled by the administrator',
      tooManyFailedAttempts: 'Too many failed attempts - Please try again later',
      unknownError: 'Unknown error, try again later',
      usernameAlreadyInUse: 'Username already in use',
      weakPassword: 'Please use stronger password',
    },
  },
};

export { error as default };
